// src/lib/supabase.ts
import { createClient, type SupabaseClient } from "@supabase/supabase-js";

/**
 * In production (Cloudflare Pages), if env vars are not set, creating the real client
 * can still cause runtime crashes inside the SDK. This file returns a safe mock client
 * when VITE_SUPABASE_URL / VITE_SUPABASE_ANON_KEY are missing, so the UI never crashes.
 */

const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const key = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

function makeMock(): SupabaseClient {
  // minimal surface we use in the app
  const mock = {
    auth: {
      getSession: async () => ({ data: { session: null }, error: null }),
      onAuthStateChange: (
        _cb: (event: any, session: any) => void
      ) => ({
        data: {
          subscription: {
            unsubscribe() {
              /* no-op */
            },
          },
        },
      }),
      async signInWithOAuth() {
        alert(
          "Supabase env vars are not configured yet. Add VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY to your Cloudflare Pages project → Settings → Environment variables."
        );
        return { data: null, error: null } as any;
      },
      async signOut() {
        return { data: null, error: null } as any;
      },
    },
  } as unknown as SupabaseClient;

  if (import.meta.env.PROD) {
    // keep the page visible but log once in production
    console.warn(
      "Supabase running in mock mode (missing VITE_SUPABASE_URL or VITE_SUPABASE_ANON_KEY)."
    );
  }
  return mock;
}

export const supabase: SupabaseClient =
  url && key ? createClient(url, key) : makeMock();
